// Параметры Cognito User Pool
const awsmobile = {
  aws_user_pools_id: 'eu-west-1_xDSLO8zYu',
  aws_user_pools_web_client_id: '5g8j7k402lve61l02nt9sue8au',
};

export default awsmobile;
